export default {
  config: {
    apiAddress: process.env.API_SERVER || `https://${location.hostname.replace('panel', 'api')}`,
    apiTimeout: 10 * 1000,
    carrotQuest: process.env.CARROT_QUEST || null,
    checkingUpdates: process.env.NODE_ENV === 'production',
    checkingUpdatesInterval: 10 * 60 * 1000,
    colorCards: false,
    debug: process.env.NODE_ENV !== 'production',
    domain: process.env.DOMAIN || 'd2c.io',
    domains: ['d2c.io'],
    facebookPixel: process.env.FACEBOOK_PIXEL || null,
    homePath: '/dashboard',
    maintenance: process.env.MAINTENANCE || false,
    notificationsCount: 9,
    notificationsDelay: 10 * 1000,
    notificationsOrder: 0,
    offline: false,
    owner: false,
    s3PublicUrl: process.env.S3_PUBLIC_URL,
    tracking: process.env.TRACKING || false,
    uploadSize: 50 * 1024 * 1024,
    users: {},
    wsAddress: process.env.WS_SERVER || `https://${location.hostname.replace('panel', 'ws')}`,
    yandexMetrika: process.env.YANDEX_METRIKA || null,
  },
  userConfig: {},
  sessionConfig: {},
  connected: false,
  lastProviderId: null,
  token: '',
  version: process.env.D2C_VERSION || '0.0.0',
  // dict
  instancesById: {},
  regionsById: {},
  tariffsById: {},
  user: {},
  // entitiesById
  accountsById: {},
  containersById: {},
  hostsById: {},
  keysById: {},
  membersById: {},
  projectsById: {},
  providersById: {},
  rolesById: {},
  servicesById: {},
  // stats
  hostStats: {},
  containerStats: {},
}
